import { render, staticRenderFns } from "./reportBackupReport.vue?vue&type=template&id=77b2f220&scoped=true&"
import script from "./reportBackupReport.vue?vue&type=script&lang=js&"
export * from "./reportBackupReport.vue?vue&type=script&lang=js&"
import style0 from "./reportBackupReport.vue?vue&type=style&index=0&id=77b2f220&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b2f220",
  null
  
)

export default component.exports